import React, { useMemo } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import type { AuthStackParamList } from './types';
import { useThemeStore } from '../shared/theme';
import { renderRegistryStackScreens } from './stackScreenFactory';
import { getAuthStackInitialRoute } from '../exDev/environment/devInitialScreens';
import { createStackScreenOptions } from '../shared/navigation/stackScreenOptions';

const Stack = createNativeStackNavigator<AuthStackParamList>();

/** Unauthenticated stack — screens from `shared/navigation/screenRegistry`. */
export function AuthStackNavigator() {
  const appearance = useThemeStore(state => state.appearance);

  const ios_status_bar_style = useMemo(
    () => (appearance === 'dark' ? 'light' : 'dark') as 'light' | 'dark',
    [appearance],
  );

  return (
    <Stack.Navigator
      screenOptions={createStackScreenOptions(ios_status_bar_style)}
      initialRouteName={getAuthStackInitialRoute()}>
      {renderRegistryStackScreens(Stack, 'auth')}
    </Stack.Navigator>
  );
}
